/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_options.js                                                                         */
/**********************************************************************************************************************/
/* Controller.Options */

/**
 * @class this.Controller.Options
 */
HafasWebapp.prototype.Controller.Options = {

  _getAppContext: function (params) {
    var currentContext = this.appContext;
    if (params && params.hasOwnProperty('context')) {
      currentContext = params.context;
    }
    return currentContext;
  },

  /**
   * Saves the options model into the context specific options instance if there are modified options
   * @param {object} params Params that will be forwarded to _getAppContext from the options controller
   */
  storeChangedOptionModel: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    if (this.Controller[context] && this.Controller[context].options) {
      var storedOptions = this.Controller[context].options.buildOptionModel(true, null);
      if (storedOptions.hasOwnProperty('mod')) {
        this.Controller[context].options.storeOptionModel(storedOptions);
      }
    }
  },

  /**
   * Gets the stored options out of the storage and injects them into the context specific options instance
   * @param {object} params Params that will be forwarded to _getAppContext from the options controller
   */
  useStoredOptionModel: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    if (this.Controller[context] && this.Controller[context].options) {
      var storedOptions = this.Controller[context].options.getOptionStorage();
      if (storedOptions != null) {
        this.Controller[context].options.injectModifiedModel(storedOptions.mod, {skipVias: true});
      }
    }
  },

  /**
   * get specific options model by name
   *
   * @method module.get
   * @params name
   * @return {object} the existing model
   */
  getModelByName: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var model = this.Controller[context].options.getModelByName({name: params.name});
    return model;
  },

  /**
   * get specific options model by name
   *
   * @method module.get
   * @params name
   * @return {object} the existing model
   */
  getModelById: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var model = this.Controller[context].options.getModelById({id: params.id});
    return model;
  },

  getOptionTexts: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var text = this.Controller[context].options.getOptionTexts(params);
    return text;
  },

  setOptionValue: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    Hafas.ps.pub('/' + context.toLowerCase() + '/options/activateLocalStorage', [true]);
    this.Controller[context].options.setRandomParameter(params.id, 'value', params.value);
  },

  setOptionParameter: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    Hafas.ps.pub('/' + context.toLowerCase() + '/options/activateLocalStorage', [true]);
    this.Controller[context].options.setRandomParameter(params.id, params.parameter, params.value);
  },

  setProducts: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    this.Controller[context].options.setOptionModel(params);
    Hafas.ps.pub('/options/gui/render');
  },

  // currently missing: function getProductClass() in stboard /mroe
  resetProducts: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var parentContainer = params.element.parentNode;
    // TEMP (default checked status for products has to be defined in the data model)
    this.Controller[context].instance.setProductClass(8191, true);
    var model = {products: this.Controller.Common.productSelection(this.Controller[context].instance.getProductClass(), context)};
    Hafas.Modules.Render.render({target: parentContainer, template: 'Common_Tab1', model: model});
  },

  setProductSelection: function (context, params, enable) {
    var productList = Hafas.Util.products.getForContext(context);
    for (var i = 0; i < productList.length; i++) {
      var id = "HFS_" + productList[i].id;
      this.Controller[context].options.setRandomParameter(id, 'value', enable);
    }
    Hafas.ps.pub('/options/gui/render', [{groupId: params.groupId}]);
  },
  /**
   * function sets the products accordingly to the definition of the quick filter action button
   * action is called when user hits a quick action button like "Only regio trains"
   *
   * @method setProductsByQuickFilter
   * @param {String} applicationContext the respective context for the options to be modified
   * @param {Object} quickFilterDataModel returns the data model that can be used to overwrite client settings
   * **/
  setProductsByQuickFilter: function(params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      Hafas.bind(this.Controller.Options.setProductSelection, this)(context, {groupId: params.groupId}, true);
      // Get all product switch HTML elements in order to read their productbit value and set their checked status accordingly
      var productSwitchElements = Hafas('[data-render-element="options_content"] input[data-productbit]',true);
      productSwitchElements.forEach(function(productSwitch){
        var productbit = parseInt(productSwitch.getAttribute("data-productbit"));
        // Do bit linking in order to find out if an element needs to be deselected
        if ((params.value & productbit) != productbit) {
          this.Controller[context].options.setRandomParameter(productSwitch.id, 'value', false);
        }
      }.bind(this));
      Hafas.ps.pub('/options/gui/render', [{groupId: params.groupId}]);
  },
  setAllProducts: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    Hafas.bind(this.Controller.Options.setProductSelection, this)(context, params, true);

    this.Controller[context].options.announceCurrentProducts();
  },
  setRegioProducts: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    Hafas.bind(this.Controller.Options.setProductSelection, this)(context, {groupId: params.groupId}, true);
    this.Controller[context].options.setRandomParameter("HFS_ICE", 'value', false);
    this.Controller[context].options.setRandomParameter("HFS_IC", 'value', false);
    this.Controller[context].options.setRandomParameter("HFS_IR", 'value', false);
    Hafas.ps.pub('/options/gui/render', [{groupId: params.groupId}]);

    this.Controller[context].options.announceCurrentProducts();
  },

  initOptions: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var selectIds = this.Controller[context].options.getModelsByType("select");
    for (var i = 0; i < selectIds.length; i++) {
      var callback = function (params) {
        Hafas.ps.pub('/options/set/value', [{id: params.trigger.id, value: params.value}]);
      };
      Hafas.Core.newType('HafasSelectBox', {holder: selectIds[i].id + '_Holder', callback: callback}).initiate();
    }
    Hafas.ps.pub('/' + context + '/options/init', [this.Controller[context].options.get()]);
  },

  resetOptions: function (announceIt) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)({});
    this.Controller[context].options.reset({app: context, announceIt: announceIt});
    if (context === 'SQ') {
      Hafas.ps.pub('/sq/clearDirection/webapp');
    }
    if (context === 'TP' && !Hafas.Config.TP.vias.showInForm) {
      Hafas.ps.pub('/tp/clearViaSuggests');
    }
    Hafas.ps.pub('/options/gui/render');
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
    Hafas.ps.pub('/' + context.toLowerCase() + '/options/activateLocalStorage', [true]);
  },

  haveOptionsChanged: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var boolval = this.Controller[context].options.haveOptionsChanged();
    return boolval;
  },

  GUI: {
    renderOptions: function (params) {
      var focusSelector = Hafas.Util.gui.getFocusElementSelector();
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)({});
      var parentContainer = Hafas("#HFS_CustomerOptionsWrap");
      // get scrollcontainer with scrollbar, save scrolltop if container is available
      var scrollContainer = Hafas(".lyr_flexScrolledContainer", true, parentContainer)[0];
      if (scrollContainer) {
        var scrollTop = scrollContainer.scrollTop;
      }
      var tabcontent = this.Controller[context].options.get();
      var optionsChanged = this.Controller[context].options.haveOptionsChanged();
      var model = {
        name: Hafas.Modules.i18n.get('common.label.t_N_Options'),
        tpl: 'Common_AtomTplOptions',
        tabcontent: tabcontent,
        tabid: 'HFS_CustomerOptions',
        optionsChanged: optionsChanged,
        hideMainNavigation: false
      };
      // Options should be hidden when the user is on a sub-options-page; exception: main navigation should still visible,
      // e.g. in Classic preset > SQ (products directly opened in options, not on sub-page),
      // therefore we check hidden-attribute of main navigation here
      var optionsMainHeader = Hafas("[data-option-navigation='main']");
      if (params && params.hasOwnProperty('groupId') && optionsMainHeader && optionsMainHeader.hidden === true) {
        model.hideMainNavigation = true;
      }
      Hafas.Modules.Render.render({target: parentContainer, template: 'Common_AtomTplOptions', model: model});
      Hafas.ps.pub('/options/init');
      // via-felder nach dem Zur�cksetzen neu initiieren
      if (context == "TP") {
        Hafas.ps.pub('/TP/options/init', [tabcontent]);
      }
      if (context == "SQ") {
        Hafas.ps.pub('/SQ/options/init', [tabcontent]);
      }
      // Hafas.ps.pub('/GUI/common/fixedElements/setHeights', [{me: this}]);
      Hafas.ps.pub('/options/setChangedOptionsInputForm');
      if (params && params.groupId) {
        var screen = this.Controller[context].options.getModelById({id: params.groupId}).screen;
        if (screen === "drilldown") {
          var options = this.Controller[context].options.get();
          for (var i = 0; i < options.questionList.length; i++) {
            var optionElement = null;
            if (options.questionList[i].id !== params.groupId) {
              optionElement = Hafas("#" + options.questionList[i].id + "_Container");
            } else {
              optionElement = Hafas("#" + options.questionList[i].id + "_Tab");
            }
            Hafas.Util.gui.setVisibility(optionElement, false);
            // If available, hide button for additional information as well
            if (options.questionList[i].additionalText !== undefined) {
              Hafas.Util.gui.setVisibility(Hafas("#" + options.questionList[i].id + "_AdditionalTextBtn"), false);
            }
          }
        }
      }
      // get new rendered scrollcontainer to set scrolltop, set scrollTop if both values (container and scrollTop) are avaialble
      scrollContainer = Hafas(".lyr_flexScrolledContainer", true, parentContainer)[0];
      if (scrollContainer && scrollTop) {
        scrollContainer.scrollTop = scrollTop;
      }
      Hafas.Util.gui.restoreFocus(focusSelector);
    },
    /**
     * Function to fill the changed options container on the application's input form
     * with a changed options text
     *
     * @method module.setChangedOptionsInputForm
     * @params {object} params | params.parentContainer: the container for changed options |
     *                           params.template: the template to use for the changed options text
     */
    setChangedOptionsInputForm: function (params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      if (typeof this.Controller[context].options == 'undefined') {
        return;
      }
      var model = this.Controller[context].options.getOptionTexts();
      var parentContainer = Hafas("[data-additional-info='selected_options_" + context + "']");
      var parentTextualContainer = Hafas("[data-additional-info='selected_optionsTextual_" + context + "']");
      var detailsContainer = Hafas("[data-additional-info='selected_products_" + context + "']");
      if ((typeof params != "undefined") && (params.hasOwnProperty('parentContainer'))) {
        parentContainer = params.parentContainer;
      }
      // Display changed settings as a button
      if ((parentContainer != null) && (model.infoText != "")) {
        // var template = 'Common_AtomTplButton';
        var template = 'Common_AtomTplOptionInfo';
        var file = 'common.options.html';
        // Hafas.Modules.Atoms.append('common.options.changedOptionInfo', {model: model});
        Hafas.Modules.Render.render(
          {
            file: file,
            target: parentContainer,
            template: template,
            model: model
          }, function () {
            Hafas.ps.pub('/app/events/resize');
          });
      } else if ((parentContainer != null) && (model.infoText == "")) {
        parentContainer.innerHTML = "";
      }
      // Display changed settings as text
      if ((parentTextualContainer != null) && (model.infoText != "")) {
        var template = 'Common_AtomTplOptionResInfo';
        var file = 'common.options.html';
        Hafas.Modules.Render.render(
            {
              file: file,
              target: parentTextualContainer,
              template: template,
              model: model
            }, function () {
              Hafas.ps.pub('/app/events/resize');
            });
      } else if ((parentTextualContainer != null) && (model.infoText == "")) {
        parentTextualContainer.innerHTML = "";
      }
      if (Hafas('#HFS_OptionsButton' + context)) {
        var contextBtn = Hafas('#HFS_OptionsButton' + context);
        if (model.infoText != "") {
          contextBtn.addClassName('js_optionsChanged');
        } else {
          contextBtn.removeClassName('js_optionsChanged');
        }
      }
      if ((detailsContainer != null) && (model.prodText != "")) {
        // Rendering product changes
        if (model.prodText != "") {
          Hafas.Modules.Render.render({
            file: 'common.options.html',
            target: detailsContainer,
            template: 'Common_AtomTplOptionInfoProducts',
            model: model
          }, function () {
            Hafas.ps.pub('/app/events/resize');
          });
        }
      } else if ((detailsContainer != null) && (model.prodText == "")) {
        detailsContainer.innerHTML = "";
      }
    },

    toggleOptionDialog: function (params) {
      var focusSelector = Hafas.Util.gui.getFocusElementSelector(); // Remember focused element to restore later
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      var $coreForm = Hafas('[data-render-element="fieldset_wrapper"]', false);
      var $favoritesWrap = Hafas('[data-render-element="favorites_container"]', false);
      // Neue Toggle-Funktion mit ARIA-Attributen (Barrierefreiheit)
      // Gibt neuen status zurück
      var _visibleOptions = Hafas.ps.pub('/GUI/common/atomToggleContainer', [params]);

      // Tracking, nur wenn Optionen sichtbar gemacht werden (wegschalten wird nicht getrackt)
      if (_visibleOptions === true) {
        if (context === 'TP') {
          Hafas.ps.pub('/tracking/screen/connection-options-main', [{
            typ: 'screen',
            key: 'connection-options-main'
          }]);
          Hafas.ps.pub('/tracking/screen/tripplanner-options-main', [{
            typ: 'screen',
            key: 'tripplanner-options-main'
          }]);
          Hafas.ps.pub('/tracking/event/tripplanner-options-pressed', [{
            typ: 'screen',
            key: 'tripplanner-options-pressed'
          }]);
        }
        if (context === 'SQ') {
          Hafas.ps.pub('/tracking/screen/stationboard-options-main', [{
            typ: 'screen',
            key: 'stationboard-options-main'
          }]);
          Hafas.ps.pub('/tracking/event/stationboard-options-pressed', [{
            typ: 'screen',
            key: 'stationboard-options-pressed'
          }]);
        }
      }

      if (Hafas.Modules.History) {
        if (_visibleOptions) {
          Hafas.Modules.History.addOrUpdateData(context, params.view, {previousFocusSelector: focusSelector});
        } else {
          Hafas.Modules.History.removeCurrentStep(params.view);
        }
      }

      // Navigation-Header für Optionen-Main-Screen anzeigen
      if (_visibleOptions) {
        var visibleHeader = Hafas("[data-option-navigation='main']");
        this.Controller.Options.GUI.showOptionHeader(visibleHeader);
      }

      // Don't hide favorites/history in formbased planner mode unless it's small layout
      if(!Hafas.Util.isFormBased() || Hafas('#HFS_WebApp',false).hasClassName('mq-small') == true) {
        Hafas.Util.gui.setVisibility($favoritesWrap, !_visibleOptions);
      }

      // Im Falle, dass der Unified Planner angeschaltet ist: auch den Ergebniscontainer ausblenden
      var $resultContainer;
      if (context === "TP") {
        $resultContainer = Hafas("#TP_ResultOverview");
        if ($resultContainer && Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.Util.gui.setVisibility($resultContainer, !_visibleOptions);
        }
      } else       // Im Falle, dass der Unified Planner angeschaltet ist: auch den Ergebniscontainer ausblenden
      if (context === "SQ") {
        $resultContainer = Hafas("#SQ_ResultOverview");
        if ($resultContainer && Hafas.Config.SQ.unifiedPlanner.show) {
          Hafas.Util.gui.setVisibility($resultContainer, !_visibleOptions);
        }
      }

      if ((typeof _visibleOptions != 'undefined' && _visibleOptions === true)) {
        switch (context) {
          case 'TP':
            Hafas.ps.pub('/tracking/event/journey-planner-options', [{typ: 'event', key: 'journey-planner-options'}]);
        }
      }

      // .lyr_flexHeader vom DocumentFormWrapper entfernen, wenn wir in den Optionen sind, da sonst Scrollprobleme auftauchen
      if (Hafas.getWebAppContext() === "TP" && Hafas.Config.Switches.useTravelplanner === true && Hafas.Config.TP.unifiedPlanner.show) {
        this.Controller.TP.setFormForOverview(!_visibleOptions);
      }

      //announce Header Text and focus first Element
      if (_visibleOptions) {
        //announce header text
        var actionbarTitle = Hafas(".lyr_atomActionbarTitle", true, Hafas("[data-option-navigation='main']"));
        if (actionbarTitle.length > 0) {
          Hafas.Modules.a11y.Announce.assertive(actionbarTitle[0].innerText);
        }
        // focus first Element (Backbutton)
        Hafas.Util.gui.focusFirstElement("[data-option-navigation='main']");
      }
      if (context === "TP") {
        //announce header text
        var actionbarTitle = Hafas(".lyr_atomActionbarTitle", true, Hafas("#TP_ResultActionbar"));
        if (actionbarTitle.length > 0) {
          Hafas.Modules.a11y.Announce.assertive(actionbarTitle[0].innerText);
        }
        // focus first Element (Backbutton)
        Hafas.Util.gui.focusFirstElement("#TP_ResultActionbar");
      }

      // Barrierefreiheit: Webapp beginnt erst mit Suche, obwohl eigentlich Optionen zu sehen sind.
      // TODO: Gibt es einen Parameter der beides parallel anzeigt?

      // Don't hide the form in formbased planner mode unless it's small layout
      if(!Hafas.Util.isFormBased() || Hafas('#HFS_WebApp',false).hasClassName('mq-small') == true) {
        Hafas.Util.gui.setVisibility($coreForm, !_visibleOptions);
      }

      // Check for onboarding tooltips to be displayed
      if(_visibleOptions) {
        Hafas.bind(this.Controller.Options.GUI.renderOnboardingTooltips,this)(context);
      }

      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/events/resize');
    },
    renderOnboardingTooltips: function(context){
      // Omit overflow CSS statements by adding a temporary class
      var onboardingTooltips = Hafas('#DocumentOptionsWrapper [data-onboarding-tooltip]',true);
      // Iterate through all tooltips and show tooltip (respecting the order)
      if(onboardingTooltips.length > 0) {
          Hafas.bind(this.Controller.Options.GUI.showOnboardingTooltip,this)(onboardingTooltips, 0, context);
      }
    },
    showOnboardingTooltip: function(tooltips, index, context){
      var tooltipWrapperContainer = tooltips[index];
      Hafas.ps.pub('/gui/showOnboardingToolTip', [{
        id: tooltipWrapperContainer.dataset.onboardingTooltip,
        context: context,
        anchorElement: tooltipWrapperContainer,
        closeCallback: function(tooltipsLocal, indexLocal, selfContext){
          return function(){
            // Check if next tooltip is available, if so show it
            if(tooltipsLocal[indexLocal+1] !== undefined) {
              Hafas.bind(selfContext.Controller.Options.GUI.showOnboardingTooltip, selfContext)(tooltipsLocal, indexLocal + 1, context);
            }
          }
        }(tooltips,index,this)
      }]);
    },
    toggleOptionGroup: function (params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      var panelModel = this.Controller[context].options.getModelById({id: params.groupId});
      var screen = panelModel.screen;
      if (Hafas.Modules.History.getCurrentData().data) //verhindert überschreiben des previousFocus, falls dieser gesetzt war
        params.previousFocusSelector = Hafas.Modules.History.getCurrentData().data.previousFocusSelector;
      // Hafas.ps.pub('/GUI/options/optionGroup/toggle', [{trigger: params.trigger, target: params.target, screen: params.screen}]);
      if (Hafas.Modules.History && (screen == "drilldown"))
        Hafas.Modules.History.addOrUpdateData(context, params.view, params);

      var display = "block";
      var openState = true;
      if (panelModel.display == "block") {
        display = "none";
        openState = false;
      }

      this.Controller[context].options.setRandomParameter(panelModel.id, 'display', display);

      if (screen == "drilldown") {
        if (openState) {
          // Navigation-Header für Optionen-Details-Screen anzeigen
          // Anpassung ngr: Da es auch mehrere Drilldowns geben kann, funktionierte die alte Abfrage nicht; diese brachte ein Array zustande; darum Umstellung auf die ID
          var visibleHeader = Hafas("[data-option-origin='" + params.groupId + "']");
          this.Controller.Options.GUI.showOptionHeader(visibleHeader);
        }
        // Scrollbereich aus der Main-Option-Page zur Unterseite verschieben
        var optionContentMain = Hafas("[data-render-element='options_content']");
        var panelContainer = Hafas("#" + panelModel.id + "_Container");
        if (optionContentMain && openState) {
          optionContentMain.removeClassName("lyr_flexScrolledContainer");
          optionContentMain.addClassName("lyr_flexContainer");
          panelContainer.addClassName("lyr_flexContainer");
        } else if (optionContentMain && !openState) {
          optionContentMain.addClassName("lyr_flexScrolledContainer");
          optionContentMain.removeClassName("lyr_flexContainer");
          panelContainer.removeClassName("lyr_flexContainer");
        }

        /** Inaktive Optionen müssen ganz ausgeblendet werden, damit sie nicht hinter/unter dem aktiven Detail-Container zu sehen sind **/
        var showOptions = false;
        if (display == "none") {
          showOptions = true;
        }
        var options = this.Controller[context].options.get();
        for (var i = 0; i < options.questionList.length; i++) {
          var optionElement = null;
          if (options.questionList[i].id != panelModel.id) {
            optionElement = Hafas("#" + options.questionList[i].id + "_Container");
          } else {
            optionElement = Hafas("#" + options.questionList[i].id + "_Tab");
          }
          Hafas.Util.gui.setVisibility(optionElement, showOptions);
          // If available, hide button for additional information as well
          if (options.questionList[i].additionalText !== undefined) {
            Hafas.Util.gui.setVisibility(Hafas("#" + options.questionList[i].id + "_AdditionalTextBtn"), false);
          }
        }

      }

      if (screen === 'fold') {
        params.scroll = true;
      }

      var newExpandedStatus = Hafas.ps.pub('/GUI/common/atomToggleContainer', [params]);

      var tooltipText = Hafas('.lyr_tooltipText', true, params.trigger);
      if (tooltipText.length > 0) {
        if (typeof newExpandedStatus !== "undefined" && newExpandedStatus === true) {
          tooltipText[0].innerHTML = Hafas.Modules.i18n.get('common.label.t_N_HideOption', {OptionName: panelModel.label});
        } else {
          tooltipText[0].innerHTML = Hafas.Modules.i18n.get('common.label.t_N_ShowOption', {OptionName: panelModel.label});
        }
      }

      // Focus first element in a drilldown (Services / Verkehrsmittel)
      if(newExpandedStatus === true && screen === 'drilldown') {
        Hafas.Util.node.getFirstVisibleAndFocusableElement(optionContentMain).focus();
      }

      this.Controller[context].options.getModelByName({name: params.target});
      Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
    },

    // Funktion sorgt bei Optionen dafür, dass immer nur eine Navigationszeile/Navigationsheader angezeigt wird (der übergebene)
    showOptionHeader: function (visibleHeader) {
      var navigationHeaderList = Hafas("[data-render-element='result_view_header']");

      // TabNavigationHeading vollständig ausblenden, wenn es eine Optionen-Actionbar gibt
      var tabNavigation = document.getElementById("HFS_TabNavigation");
      tabNavigation.classList.add('lyr_layoutSmallHide');

      // alle sichtbaren Navigationsleisten ausblenden
      for (var i = 0; i < navigationHeaderList.length; i++) {
        Hafas.Util.gui.setVisibility(navigationHeaderList[i], false);
      }
      // Übergebenes Element einblenden
      Hafas.Util.gui.setVisibility(visibleHeader, true);
    },

    // Bei Kontextwechsel müssen Optionen-Gruppen (zB. Verkehrsmittelauswahl) ggf. datenseitig auf Standard-Zustand zurückgesetzt werden
    closeAllOptionGroups: function (params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      var optiongroupIds = this.Controller[context].options.getModelsByType("optiongroup");
      for (var i = 0; i < optiongroupIds.length; i++) {
        var display = this.Controller[context].options.getStandardParameter("display", optiongroupIds[i].id);
        this.Controller[context].options.setRandomParameter(optiongroupIds[i].id, 'display', display);
      }
    },

    toggleViaOptions: function (params) {
      if (params.id && params.hasOwnProperty('visibility')) {
        var activatedFields = Hafas("#" + params.id + "_Container [data-via-field='toggle']", true);
        var visibility = params.visibility;
        for (var i = 0; i < activatedFields.length; i++) {
          Hafas.Util.gui.setVisibility(activatedFields[i], visibility);
        }
      }
      // console.log("this.Controller.Options", this.Controller.Options);
      Hafas.bind(this.Controller.Options.GUI.toggleDeleteButton, this)  (params);
    },

    toggleDeleteButton: function (params) {
      var deleteButtons = Hafas("#" + params.id + "_Container [data-field='delete']", true);
      var visibility = params.visibility;
      for (var i = 0; i < deleteButtons.length; i++) {
        Hafas.Util.gui.setVisibility(deleteButtons[i], visibility);
      }
    },

    /**
     * Show popover or overlay with additional information regarding the option (group)
     * @param {Object} params: Content and configuration for popover/overlay
     * @param {string} params.additionalInfoText: i18n path of text (which could contain html) which has to be displayed
     * @param {boolean} params.showInOverlay: if true, content will be displayed in overlay, otherwise as popover
     * @param {Object} triggerElem: element which was clicked; necessary for anchor
     */
    showAdditionalInformation: function (params, triggerElem) {
      let additionalInfoText = Hafas.Modules.i18n.get(params.additionalInfoText);
      // Remove links if external links should be suppressed
      if (Hafas.Config.Switches.useTerminalMode) {
        additionalInfoText = Hafas.Util.removeHyperlinks(additionalInfoText);
      }
      // If a lot of text needs to be displayed, this can be done as an overlay; by default and for little text as a popover
      let overlayDisplayMode = (params.showInOverlay === undefined || params.showInOverlay === false) ? "popover" : "overlay";
      this.Controller.Options.GUI.popover = Hafas.Core.newType("HafasOverlay", {
        app: this,
        title: '',
        anchorElement: triggerElem,
        anchoredOverlay: (overlayDisplayMode === 'popover') ? 'DESKTOP' : '',
        outputHTML: additionalInfoText,
        cssClass: 'lyr_additionalOptionInformationOverlay',
        closeViaCancel: (overlayDisplayMode === 'popover'),
        closeButtonTxt: 'common.label.t_N_Close',
        onClose: function () {
          this.Controller.Options.GUI.popover = null;
        }.bind(this),
        callback: function (html, err) {}
      });
    }
  }

};
